import PropTypes from 'prop-types';

export const configManagerPropType = PropTypes.shape({
  register: PropTypes.func.isRequired,
  swap: PropTypes.func.isRequired,
  unregister: PropTypes.func.isRequired,
});

export const stateManagerPropType = PropTypes.shape({
  createURL: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired,
  unlisten: PropTypes.func.isRequired,
});

export const withKeysPropType = keys => (props, propName, componentName) => {
  const prop = props[propName];
  if (prop) {
    for (const key of Object.keys(prop)) {
      if (keys.indexOf(key) === -1) {
        return new Error(
          `Unknown \`${propName}\` key \`${key}\`. Check the render method ` +
            `of \`${componentName}\`.`
        );
      }
    }
  }
  return undefined;
};



// WEBPACK FOOTER //
// ./src/core/propTypes.js